/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { z } from "zod";

/**
 * @description Thématique des actualités :\n- ACTUALITES : Actualités générales\n- IA_NOTARIAT : IA & Notariat\n- VENTES_INTERACTIVES_36_H_IMMO : Les ventes interactives 36h immo\n- CONSEILS_ASTUCES : Conseils et astuces\n
 */
export const actualiteThemeSchema = z.enum(["ACTUALITES", "IA_NOTARIAT", "VENTES_INTERACTIVES_36_H_IMMO", "CONSEILS_ASTUCES"]).default("ACTUALITES").describe("Thématique des actualités :\n- ACTUALITES : Actualités générales\n- IA_NOTARIAT : IA & Notariat\n- VENTES_INTERACTIVES_36_H_IMMO : Les ventes interactives 36h immo\n- CONSEILS_ASTUCES : Conseils et astuces\n")